import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { CSVLink } from 'react-csv';
import {
  buildGatewayUrl, getFilesFromDirectory, initIPFS,
} from '../../../../state/ipfs';
import CustomBtn from '../../../../generic/CustomBtn';
import PreviewSampleZone from '../PreviewSampleZone/PreviewSampleZone';
import MapMini from '../../../../components/Map/components/MapMini/MapMini';

const PreviewReport = ({ step, prevPage, totalData, previewData, currentStage, handleDataUpload }) => {
  const [filesNames, setFilesNames] = useState([]);
  const translate = useIntl();

  const currentStageInfo = totalData.stagesInfo?.find((item) => item.stage === currentStage);
  const currentSubZone = totalData.subZones?.find((item) => item.subId === currentStageInfo?.subId);
  const targetSampleZones = totalData.sampleZones.filter((item) => item.subId === currentStageInfo?.subId);
  const origin = window?.location?.origin || '';
  const csvData = (previewData?.sampleZones || []).flatMap((zone) => (zone.sampleTrees || []).map((tree, index) => {
    const treeName = tree.treeName || (tree.id ? `${zone.sampleName}_T${tree.id}` : zone.sampleName);
    const treePhoto = tree.treePhoto ? `${origin}/ipfs-image?cid=${tree.treePhoto}` : '';
    const treeTag = tree.labelPhoto ? `${origin}/ipfs-image?cid=${tree.labelPhoto}` : '';
    return {
      'Name Zone': index === 0 ? (zone.sampleName || '') : '',
      'Name trees': treeName || '',
      'Tree status': tree.status || '',
      'Height, m': tree.height || '',
      'Circumference, cm': tree.diameter || '',
      'Tree photo': treePhoto ? `=HYPERLINK("${treePhoto}";"Open")` : '',
      'Tree tag': treeTag ? `=HYPERLINK("${treeTag}";"Open")` : '',
    };
  }));

  useEffect(async () => {
    if (step === 2) {
      if (currentStageInfo.filesCidDir) {
        const ipfs = await initIPFS();
        const updateArray = await getFilesFromDirectory(ipfs, currentStageInfo.filesCidDir);
        setFilesNames(updateArray.map((item) => item.path));
      } else {
        setFilesNames([]);
      }
    }
  }, [step]);

  if (step !== 2) {
    return null;
  }

  return (
    <>
      <div className="upload-wizard__monitoring">
        <div className="upload-wizard__monitoring-info">
          <div className="upload-wizard__monitoring-area">
            <span>
              {translate.formatMessage({ id: 'previewReport.areaHectares' })}
            </span>
            <p className="upload-wizard__monitoring-value">
              {totalData.subZones.reduce((sum, current) => sum + +current.square, 0)}
            </p>
          </div>
          <div className="upload-wizard__monitoring-area">
            <span>
              {translate.formatMessage({ id: 'previewReport.numberOfSamplePlots' })}
            </span>
            <p className="upload-wizard__monitoring-value">
              {totalData.sampleZones.length}
            </p>
          </div>
        </div>
        <MapMini state={{ ...totalData, subZones: [currentSubZone], sampleZones: targetSampleZones }} />
      </div>
      <div className="upload-wizard__sz-list">
        {!!(previewData?.sampleZones || []).length && (
          <CSVLink
            data={csvData}
            filename={`sample-zones-stage-${currentStage || 1}.csv`}
            className="btn btn__download-zone upload-wizard__download-csv"
            separator=";"
          >
            {translate.formatMessage({ id: 'previewSampleZone.downloadCsv' })}
          </CSVLink>
        )}
        {previewData?.sampleZones?.length && previewData.sampleZones.map((zone) => (
          <PreviewSampleZone
            sampleName={zone.sampleName}
            sampleRadius={zone.sampleRadius}
            coordinates={zone.coordinates}
            sampleTrees={zone.sampleTrees}
            isPreviousStage
            key={`${zone.sampleName}${zone.id}`}
          />
        ))}
      </div>
      <div className="upload-preview_subinfo">
        {!!filesNames.length && (
        <div className="upload-preview_subinfo-wrapper">
          <h4 className="upload-preview_documents-label">
            {translate.formatMessage({ id: 'previewReport.additionalDocuments' })}
          </h4>
          <div className="upload-preview_documents-list">
            {filesNames.map((item, index) => (
              <a
                className="upload-preview_documents-item"
                href={buildGatewayUrl(currentStageInfo.filesCidDir, item)}
                target="_blank"
                rel="noreferrer"
                key={item}
              >
                {`${index + 1}. ${item}`}
              </a>
            ))}
          </div>
        </div>
        )}
        {!!currentStageInfo.additional && (
          <div className="upload-preview_subinfo-wrapper">
            <h4 className="upload-preview_documents-label">
              {translate.formatMessage({ id: 'documentData.comments' })}
            </h4>
            <p className="upload-preview_documents-comments">
              {currentStageInfo.additional}
            </p>
          </div>
        )}
      </div>
      <div className="upload-wizard__panel">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-backToEdit' })}
          handleClick={prevPage}
          type="button"
          customClass="btn__cancel"
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-submitReport' })}
          handleClick={() => handleDataUpload(totalData)}
          customClass="btn__btn-next"
        />
      </div>
    </>
  );
};

export default PreviewReport;
